<template>
  <div class="img-bg">
    <!-- <pre>{{meterWater}}</pre> -->
    <!-- <pre class="bg-light">{{ get_data.water_consumption }}</pre> -->
    <br />
    <vs-card id="id2"
      ><h5 style="font-weight: 400">Plastic Painting WWTP</h5></vs-card
    >
    <div class="div-row">
      <div class="row-col1">
        <div style="width: 100%" class="div-row1">
          <div class="m-card div-w50">
            <vs-row class="mt-2" vs-w="12"
              ><h4 class="headerText">Wastewater Consumption</h4> </vs-row
            ><br />
            <vs-row class="mt-2" vs-w="12">
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="6"
                vs-sm="12"
                vs-xs="12"
              >
                <div
                  :key="rediv"
                  style="position: relative; text-align: center"
                >
                  <h6
                    style="
                      position: absolute;
                      top: 80%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                    "
                  >
                    m<sup>3</sup>/h
                  </h6>
                  <vue-gauge
                    :refid="'type-unique-id2'"
                    :options="{
                      hasNeedle: true,
                      outerNeedle: true,
                      needleStartValue: 0,
                      needleColor: 'red',
                      arcColors: ['#66BB6A', '#E0E0E0'],
                      needleValue:
                        parseFloat(meterWater.maxflow) * percent_water,
                      arcDelimiters: [
                        parseFloat(meterWater.flow) * percent_water,
                      ],
                      centralLabel: meterWater.label.toString(),
                      rangeLabel: ['0', '50'],
                      needleUpdateSpeed: 1,
                    }"
                  ></vue-gauge>
                </div>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="6"
                vs-sm="12"
                vs-xs="12"
              >
                <ul class="demo container-fluid">
                  <li style="white-space: nowrap">
                    <h6 class="resText">
                      Day Volume :
                      <a style="font-size: 1rem; font-weight: 600">{{
                        get_data.water_consumption.flowDaily
                      }}</a>
                      m<sup>3</sup>
                    </h6>
                  </li>
                  <br />
                  <li style="white-space: nowrap">
                    <h6 class="resText">
                      Month Volume :
                      <a style="font-size: 1rem; font-weight: 600">{{
                        get_data.water_consumption.monthly
                      }}</a>
                      m<sup>3</sup>
                    </h6>
                  </li>
                  <br />
                  <li style="white-space: nowrap">
                    <h6 class="resText">
                      Year Volume :
                      <a style="font-size: 1rem; font-weight: 600">{{
                        get_data.water_consumption.yearly
                      }}</a>
                      m<sup>3</sup>
                    </h6>
                  </li>
                </ul>
              </vs-col>
            </vs-row>

            <vs-row>
              <div class="mt-1">
                <vs-icon
                  icon="arrow_drop_down"
                  size="45px"
                  color="#ff0000"
                ></vs-icon>
                <a>Max Value (Daily)</a>
              </div>
              <vs-spacer />
              <h6 class="chat-messagetime">
                {{ get_data.water_consumption.time }}
              </h6>
            </vs-row>
          </div>
          <div class="m-card div-w50">
            <vs-row vs-w="12">
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="4"
                vs-sm="4"
                vs-xs="12"
              >
                <img
                  style="width: 250px; height: 250px"
                  src="@/assets/images/gif Yamaha/source.gif"
                />
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="8"
                vs-sm="8"
                vs-xs="12"
              >
                <div>
                  <ul class="demo container">
                    <li>
                      <h3 style="font-weight: 280">Total Power Consumption</h3>
                    </li>
                    <br />
                    <li>
                      <vs-row style="align-items: center"
                        ><h1 style="font-weight: 600; font-size: 3rem">
                          {{ get_data.power_consumption.total }}
                        </h1>
                        <h5 class="ml-2">kWh</h5></vs-row
                      >
                    </li>
                  </ul>
                  <br />
                  <br />
                  <vs-row
                    ><vs-spacer />
                    <ul class="demo">
                      <li style="white-space: nowrap">
                        <h6 class="resText">
                          Year Volume :
                          <a style="font-size: 1rem; font-weight: 600">{{
                            get_data.power_consumption.yearly
                          }}</a>
                          kWh
                        </h6>
                      </li>
                      <br />
                      <li style="white-space: nowrap">
                        <h6 class="resText">
                          Month Volume :
                          <a style="font-size: 1rem; font-weight: 600">{{
                            get_data.power_consumption.monthly
                          }}</a>
                          kWh
                        </h6>
                      </li>
                    </ul>
                  </vs-row>
                </div>
              </vs-col>
            </vs-row>
            <vs-row
              ><vs-spacer />
              <h6 class="chat-messagetime">
                {{ get_data.power_consumption.time }}
              </h6>
            </vs-row>
          </div>
        </div>
        <br />
        <div style="width: 100%" class="div-row1">
          <div class="m-card div-w50">
            <vs-row class="mt-2 mb-3 al-center" vs-w="12"
              ><h4 class="headerText">Water Consumption</h4>
              <vs-spacer />
              <vs-select
                class="selectExample"
                @change="selectWater(select_water)"
                v-model="select_water"
                width="120px"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in options_graph"
                />
              </vs-select>
            </vs-row>
            <div style="position: relative; width: 100%">
              <lineChart
                :width="this.wGraphP"
                :height="230"
                :chartData="datacollection_water"
                :options="option_water"
              ></lineChart>
            </div>
            <vs-row class="aText" style="align-items: center">
              <div
                style="
                  border-radius: 20px;
                  background-color: rgba(102, 187, 106);
                  color: rgba(102, 187, 106);
                  width: 30px;
                  height: 15px;
                "
              >
                .
              </div>
              <a class="ml-1">Water Consumption</a>
              <vs-spacer />
              <div class="mr-4">
                <p style="color: #fc8200" class="mb-1">avg</p>
                <p>{{ value_water.avg.toFixed(2) }} m<sup>3</sup></p>
              </div>
              <div class="mr-4">
                <p style="color: #ff006a" class="mb-1">min</p>
                <p>{{ value_water.min.toFixed(2) }} m<sup>3</sup></p>
              </div>
              <div class="mr-4">
                <p style="color: #d400ff" class="mb-1">max</p>
                <p>{{ value_water.max.toFixed(2) }} m<sup>3</sup></p>
              </div>
            </vs-row>
          </div>
          <div class="m-card div-w50">
            <vs-row class="mt-2 mb-3 al-center" vs-w="12"
              ><h4 class="headerText">Power Consumption</h4>
              <vs-spacer />
              <vs-select
                class="selectExample"
                @change="selectPower(select_power)"
                v-model="select_power"
                width="120px"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in options_graph"
                />
              </vs-select>
            </vs-row>
            <div style="position: relative; width: 100%">
              <lineChart
                :width="this.wGraphP"
                :height="230"
                :chartData="datacollection_power"
                :options="option_power"
              ></lineChart>
            </div>
            <vs-row class="aText" style="align-items: center">
              <div
                style="
                  border-radius: 20px;
                  background-color: rgba(20, 153, 242);
                  color: rgba(20, 153, 242);
                  width: 30px;
                  height: 15px;
                "
              >
                .
              </div>
              <a class="ml-1">Power Consumption</a>
              <vs-spacer />
              <div class="mr-4">
                <p style="color: #fc8200" class="mb-1">avg</p>
                <p>{{ value_power.avg.toFixed(2) }} kWh</p>
              </div>
              <div class="mr-4">
                <p style="color: #ff006a" class="mb-1">min</p>
                <p>{{ value_power.min.toFixed(2) }} kWh</p>
              </div>
              <div class="mr-4">
                <p style="color: #d400ff" class="mb-1">max</p>
                <p>{{ value_power.max.toFixed(2) }} kWh</p>
              </div>
            </vs-row>
          </div>
        </div>
      </div>
      <div class="row-col2">
        <br />
        <h4 class="ml-2 mb-3 headerText">Consumption</h4>
        <b-table-simple
          style="overflow-y: auto; max-height: 600px"
          hover
          responsive="sm"
        >
          <b-thead style="position: sticky; top: 0; z-index: 2">
            <b-tr class="bgHeader">
              <b-th>Timestamp</b-th>
              <b-th>Power Consumption</b-th>
              <b-th>Wastewater Consumption</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="i in get_data.daysData" :key="i">
              <b-td class="fontsizetable" align="center">{{
                i.time.split(" ")[0]
              }}</b-td>
              <b-td class="fontsizetable" align="center">{{ i.power }} kW</b-td>
              <b-td class="fontsizetable" align="center"
                >{{ i.water }} m<sup>3</sup></b-td
              >
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>
    <br /><br />
  </div>
</template>

<script>
import lineChart from "./chart/Chart";
import linechart from "./chart/linechart.vue";
import VueGauge from "vue-gauge";
// import { el } from "dhx-suite/codebase/types/ts-common/dom";
export default {
  components: { VueGauge, linechart, lineChart },
  data: () => ({
    interval: null,
    percent_water: 100 / 50.01,
    aaaaa: 55,
    wGraphP: "",
    wGraphW: "",
    wGraphL: "",
    meterWater: {
      flow: null,
      maxflow: null,
      label: "",
    },
    options_graph: [
      { text: "Daily", value: 1 },
      { text: "Monthly", value: 2 },
      { text: "Yearly", value: 3 },
    ],
    select_water: 1,
    select_power: 1,
    data1: [61, 122, 107, 73, 18, 170, 135],
    data2: [18, 170, 135, 92],
    backgroundColorP: "rgba(20, 153, 242,.1)",
    borderColorP: "rgba(20, 153, 242,.9)",
    backgroundColorW: "rgba(195,157,212,.1)",
    borderColorW: "rgba(195,157,212,.9)",
    backgroundColorL: "rgba(102,187,106,.1)",
    borderColorL: "rgba(102,187,106)",
    labels: ["8 pm", "9 pm", "10 pm", "11 pm", "12 pm", "1 am", "2 am"],
    get_data: [],
    options: {
      hasNeedle: true,
      outerNeedle: true,
      needleColor: "red",
      needleStartValue: 0,
      needleValue: 70,
      arcColors: ["#66BB6A", "#E0E0E0"],
      arcDelimiters: [45],
      // centralLabel: '5',
      rangeLabel: ["0", "100"],
      centralLabel: "45",
      //   centralLabel: "40" + "(L/min)",
    },
    users: [
      {
        name: "813",
        email: "2021-09-17 08:00:00",
      },
      {
        name: "783",
        email: "2021-09-16 08:00:00",
      },
      {
        name: "123",
        email: "2021-09-15 08:00:00",
      },
      {
        name: "763",
        email: "2021-09-14 08:00:00",
      },
      {
        name: "333",
        email: "2021-09-13 08:00:00",
      },
      {
        name: "365",
        email: "2021-09-12 08:00:00",
      },
      {
        name: "153",
        email: "2021-09-11 08:00:00",
      },

      {
        name: "813",
        email: "2021-09-10 08:00:00",
      },
      {
        name: "783",
        email: "2021-09-9 08:00:00",
      },
      {
        name: "123",
        email: "2021-09-8 08:00:00",
      },
    ],
    users2: [
      {
        name: "1.77L",
        email: "2021-09-17 08:00:00",
      },
      {
        name: "2.45L",
        email: "2021-09-16 08:00:00",
      },
      {
        name: "1.77L",
        email: "2021-09-15 08:00:00",
      },
      {
        name: "2.45L",
        email: "2021-09-14 08:00:00",
      },
      {
        name: "1.77L",
        email: "2021-09-13 08:00:00",
      },
      {
        name: "2.45L",
        email: "2021-09-12 08:00:00",
      },
    ],
    datacollection_power: [],
    option_power: [],
    datacollection_water: [],
    option_water: [],
    value_power: { max: null, min: null, avg: null },
    value_water: { max: null, min: null, avg: null },
    intervalmiter: null,
    rediv: 0,
  }),
  methods: {
    async selectWater(item) {
      var label_water = [];
      var data_water = [];
      // this.data2 = [];
      var sumVal = null;
      if (item === 1) {
        this.get_data.water_daily.forEach((i) => {
          label_water.push(i.time);
          data_water.push(i.water);
        });
        this.value_water.max = Math.max.apply(Math, data_water);
        this.value_water.min = Math.min.apply(Math, data_water);
        for (var i = 0; i < data_water.length; i++) {
          sumVal += parseFloat(data_water[i]);
        }
        this.value_water.avg = sumVal / data_water.length;
      } else if (item === 2) {
        this.get_data.water_monthly.forEach((i) => {
          label_water.push(i.time);
          data_water.push(i.water);
        });

        this.value_water.max = Math.max.apply(Math, data_water);
        this.value_water.min = Math.min.apply(Math, data_water);
        for (var i = 0; i < data_water.length; i++) {
          sumVal += parseFloat(data_water[i]);
        }
        this.value_water.avg = sumVal / data_water.length;
      } else if (item === 3) {
        this.get_data.water_yearly.forEach((i) => {
          label_water.push(i.time);
          data_water.push(i.water);
        });
        this.value_water.max = Math.max.apply(Math, data_water);
        this.value_water.min = Math.min.apply(Math, data_water);
        for (var i = 0; i < data_water.length; i++) {
          sumVal += parseFloat(data_water[i]);
        }
        this.value_water.avg = sumVal / data_water.length;
      }
      this.datacollection_water = {
        labels: label_water.reverse(),
        datasets: [
          {
            backgroundColor: this.backgroundColorL,
            data: data_water.reverse(),
            borderWidth: 1.5,
            borderColor: this.borderColorL,
          },
        ],
      };
      this.option_water = {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              id: "A",
              ticks: {
                beginAtZero: true,
              },
              position: "left",
              scaleLabel: {
                display: true,
                labelString: "Water (m3)",
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: "Timestamp",
              },
            },
          ],
        },
      };
    },
    async selectPower(item) {
      var label_power = [];
      var data_power = [];
      // this.data2 = [];
      var sumVal = null;
      if (item === 1) {
        this.get_data.power_daily.forEach((i) => {
          label_power.push(i.time);
          data_power.push(i.power);
        });
        this.value_power.max = Math.max.apply(Math, data_power);
        this.value_power.min = Math.min.apply(Math, data_power);
        for (var i = 0; i < data_power.length; i++) {
          sumVal += parseFloat(data_power[i]);
        }
        this.value_power.avg = sumVal / data_power.length;
      } else if (item === 2) {
        this.get_data.power_monthly.forEach((i) => {
          label_power.push(i.time);
          data_power.push(i.power);
        });

        this.value_power.max = Math.max.apply(Math, data_power);
        this.value_power.min = Math.min.apply(Math, data_power);
        for (var i = 0; i < data_power.length; i++) {
          sumVal += parseFloat(data_power[i]);
        }
        this.value_power.avg = sumVal / data_power.length;
      } else if (item === 3) {
        this.get_data.power_yearly.forEach((i) => {
          label_power.push(i.time);
          data_power.push(i.power);
        });
        this.value_power.max = Math.max.apply(Math, data_power);
        this.value_power.min = Math.min.apply(Math, data_power);
        for (var i = 0; i < data_power.length; i++) {
          sumVal += parseFloat(data_power[i]);
        }
        this.value_power.avg = sumVal / data_power.length;
      }
      this.datacollection_power = {
        labels: label_power.reverse(),
        datasets: [
          {
            backgroundColor: this.backgroundColorP,
            data: data_power.reverse(),
            borderWidth: 1.5,
            borderColor: this.borderColorP,
          },
        ],
      };
      this.option_power = {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              id: "A",
              ticks: {
                beginAtZero: true,
              },
              position: "left",
              scaleLabel: {
                display: true,
                labelString: "Power (kWh)",
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: "Timestamp",
              },
            },
          ],
        },
      };
    },
    getDateTimeMiter() {
      if (this.get_data.water_consumption.flowDaily >= 50) {
        this.meterWater.flow = 49.99;
        this.meterWater.label = "50";
        this.meterWater.maxflow = this.get_data.water_consumption.maxflow;
      } else if (
        this.get_data.water_consumption.flowDaily < 50 &&
        this.get_data.water_consumption.flowDaily > 0
      ) {
        this.meterWater.flow = this.get_data.water_consumption.flowDaily;
        this.meterWater.label = this.get_data.water_consumption.flowDaily;
        this.meterWater.maxflow = this.get_data.water_consumption.maxflow;
      } else if (this.get_data.water_consumption.flowDaily <= 0) {
        this.meterWater.flow = 0.00001;
        this.meterWater.label = "0";
        this.meterWater.maxflow = this.get_data.water_consumption.maxflow;
      }

      return this.meterWater;
    },
     async calldata() {
      await this.$API.get(`yamaha/dashboard/plastic`).then((result) => {
        this.get_data = result.data;
      });
      await this.selectPower(this.select_power);
      await this.selectWater(this.select_water);
      this.getDateTimeMiter();
      this.rediv += 1;

      this.interval = setTimeout(async () => {
        this.calldata();
      }, 60 * 1000);
    },
  },
  async mounted() {
    this.$vs.loading();
    await this.$API.get(`yamaha/dashboard/plastic`).then((result) => {
      this.get_data = result.data;
      setTimeout(() => {
        this.$vs.loading.close();
      }, 1000);
      this.getDateTimeMiter();
    });
    this.selectPower(1);
    this.selectWater(1);

    this.interval = setTimeout(async () => {
      this.calldata();
    }, 60 * 1000);
  },
  beforeDestroy() {
    clearTimeout(this.interval);
  },
  created() {
    // console.log(window.innerWidth);
    if (window.innerWidth < 1550) {
      this.wGraphP = 330;
      this.wGraphW = 240;
      this.wGraphL = 240;
      // document.getElementById("resText").innerHTML = "String".fontsize(25);
      // document.getElementById("resText").style.fontSize= "10px";
    } else if (window.innerWidth > 1550) {
      this.wGraphP = 460;
      this.wGraphW = 330;
      this.wGraphL = 330;
    }
  },
};
</script>
<style scoped>
.al-center {
  display: flex;
  width: 100%;
  align-items: center;
}
.div-row {
  display: flex;
}
.div-row1 {
  gap: 10px;
  display: flex;
}
.row-col1 {
  width: 65%;
  margin-left: 10px;
}
.div-w50 {
  width: 50%;
  background-color: rgba(255, 255, 255, 0.75);
}
.row-col2 {
  width: 35%;
  padding: 5px;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.75);
  /* background: pink; */
}
.img-bg {
  padding: 0;
  margin: -14px;
  background-image: url("../../../../assets/images/gif Yamaha/4.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}
ul.demo {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.al1 {
  margin: 0;
  padding: 0;
}
#id2 {
  width: 200px;
  /* padding: 0;
  margin: 0; */
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.75);
  margin-bottom: 0px;
  margin-left: 15px;
  text-align: center;
}
.borderRD {
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.75);
}
.bgHeader {
  background: #32c040;
  color: #ffffff;
  /* font-size: 0.78rem; */
}
.headerText {
  font-weight: 600;
  font-size: 0.9vw;
}
.resText {
  font-size: 0.8vw;
}
.aText {
  font-size: 0.5vw;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 700px) {
  .headerText {
    font-size: 2.5vw;
  }
  .resText {
    font-size: 1.5vw;
  }
  .aText {
    font-size: 1.5vw;
  }
  .div-row {
    flex-wrap: wrap;
  }
  .div-w50 {
    width: 100%;
    margin: 10px;
  }
  .row-col1 {
    width: 100%;
    margin-left: 0px;
  }
  .div-row1 {
    display: flex;
    flex-wrap: wrap;
  }
  .row-col2 {
    width: 100%;
    margin: 10px;
    padding: 5px;
    /* margin-left: 0px; */
  }
}
@media only screen and (max-width: 767px) {
  .img-bg {
    margin: -14px;
  }
}
</style>